export const isRecentUpload = (timeStamp: number | undefined) => {
  if (!timeStamp) return false;
  const now = new Date().getTime();
  // 5 minutes ago
  const recentUploadTimestamp = now - 1000 * 5 * 60;
  return timeStamp > recentUploadTimestamp;
};
